import { render, staticRenderFns } from "./StaffPriceAdjustment.vue?vue&type=template&id=10ac58b0&"
import script from "./StaffPriceAdjustment.vue?vue&type=script&lang=js&"
export * from "./StaffPriceAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./StaffPriceAdjustment.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports